export default {
  SOLID: "lineStyle_SOLID",
  THICK: "lineStyle_THICK",
  DASHED: "lineStyle_DASHED",
  DOTTED: "lineStyle_DOTTED",
  DOTSPACED: "lineStyle_DOTSPACED",
  DOTDASH: "lineStyle_DOTDASH",
  THINDOT: "lineStyle_THINDOT"
};
